import React from 'react';
import ReactDOM from 'react-dom';
import { debounce } from 'utils/underscore_cust';
import contextService from './services/contextService';
import localeSvc from 'services/localeService';
import configureStore from './redux/configureStore';
import Root from './containers/Root';
import { hideHeader, getWinObject } from 'utils/url';
import { MESSAGE } from 'constants/message';

// window.React = React;
// window.Perf = React.addons.Perf;
const ROOT_CLASS = 'aurycEventEditor';
export const ROOT_ID = 'aurycEditorRoot';
export const HEADER_HEIGHT = 50;
const initialState = window.__INITIAL_STATE__;

const store = configureStore(initialState);

window.aurycLoadEditor = function (params) {
  contextService.setContext(params);

  // const {
  //   accessToken,
  //   accessTokenExpiresAt,
  //   appHost,
  //   bookmarkletMode, // When the editor is loaded from the bookmarklet, ignore intro/user flag stuff
  //   projectId,
  //   projectOwnerId,
  //   projectToken,
  //   readOnly,
  //   userFlags={},
  //   userId
  // } = params;

  // function isAtLoginPage (appHost) {
  //   const currentURL = window.location.href + window.location.pathname;
  //   return currentURL.indexOf(appHost + '/login') !== -1;
  // }

  return new Promise(function (resolve, reject) {
    // if (document.getElementsByClassName(EDITOR_CLASS).length || isAtLoginPage(appHost)) {
    //   reject('already loaded');
    // }

    // embed css
    // const proximaNovaStyles = document.createElement('style');
    // proximaNovaStyles.setAttribute('type', 'text/css');
    // proximaNovaStyles.innerHTML = proximaNovaCss;
    // const host = document.head ? document.head : document.body;
    // host.appendChild(proximaNovaStyles);

    // init tracking
    // const editorMode = bookmarkletMode ? 'external' : 'normal';
    // tracking.init(userId, projectId, editorMode);

    // Object.assign(Config, {
    //   accessToken,
    //   appHost,
    //   bookmarkletMode,
    //   projectId,
    //   projectOwnerId,
    //   projectToken,
    //   userId,
    // });
    // const accessTokenExpired = (accessTokenExpiresAt - (new Date()).getTime()) <= 0;
    // const editorApp = document.createElement('collect-everything-editor-app');
    // editorApp.state = {
    //   accessTokenExpired,
    //   accessTokenExpiresAt,
    //   hasCreatedFirstEvent: Config.bookmarkletMode || userFlags.COLLECT_EVERYTHING_CREATED_FIRST_EVENT === 1,
    //   needsAddElementsIntroModal: !Config.bookmarkletMode && userFlags.COLLECT_EVERYTHING_ADD_ELEMENTS_MODAL === 0,
    //   needsPropertiesIntroModal: !Config.bookmarkletMode && userFlags.COLLECT_EVERYTHING_PROPERTIES_MODAL === 0,
    //   readOnly,
    //   showCEIntroModal: !Config.bookmarkletMode && userFlags.COLLECT_EVERYTHING_INTRO_MODAL === 0,
    //   skipConfirmNavigateToEvent: Config.bookmarkletMode ||
    //                               userFlags.COLLECT_EVERYTHING_SKIP_CONFIRM_NAGIVATE_TO_EVENT === 1,
    // };

    const saveReferrer = function () {
      if (!sessionStorage.getItem('_auryc_em_referer')) {
        sessionStorage.setItem('_auryc_em_referer', window.document.referrer);
      }
    };

    // const getReferrer = function () {
    //   return sessionStorage.getItem('_auryc_em_referer');
    // };

    // const removeReferrer = function () {
    //   return sessionStorage.removeItem('_auryc_em_referer');
    // };

    const handleIframe = () => {
      let frameList = document.querySelectorAll('iframe');
      for (let i = 0; i < frameList.length; i++) {
        let fNode = frameList[i];
        let myWin = getWinObject(fNode);
        if (!myWin) {
          return;
        }

        let message = {
          source: '_ar_',
          command: MESSAGE.EXIT_EVENT_MARKER
        };

        try {
          myWin.postMessage(message, '*');
        } catch (e) {
        }
      }
    };
    const renderEditor = function () {
      // save referrer if not set
      saveReferrer();
      let _appendChild;
      let exitEditorMode = contextService.get('exitEditorMode');
      // store the last url
      function handleExit () {
        if (_appendChild) {
          document.body.appendChild = _appendChild;
        }
        exitEditorMode();
        handleIframe();

        setTimeout(function () { location.reload(); }, 500);
      }
      window.addEventListener('message', (event) => {
        const evtData = event.data;
        if (evtData.command && evtData.source && evtData.source === '_ar_') {
          const command = evtData.command;
          if (command === MESSAGE.EXIT_EVENT_MARKER) {
            let exitEditorMode = contextService.get('exitEditorMode');
            exitEditorMode();
          }
          if (command === MESSAGE.RESET_EVENT_MARKER) {
            contextService.set('position', undefined);
          }
        }
        if (evtData.position && evtData.source && evtData.source === '_ar_') {
          contextService.set('position', evtData.position);
        }
      });

      setTimeout(function () {
        // attempt to move down page elements to allow room for the header
        const hostElements = document.querySelectorAll('*');
        if (!hideHeader()) {
          shiftHostPageDown(hostElements);
        }
        const root = document.createElement('div');
        root.className = ROOT_CLASS;
        root.style.position = 'static';
        root.id = ROOT_ID;
        document.body.appendChild(root);

        ReactDOM.render(
          <Root
            store={store}
            siteId={params.siteId}
            onExit={handleExit}/>,
          document.getElementById(ROOT_ID)
        );

        // make sure the editor is the last element in the body to be always visilble
        let keepRoot = debounce(() => {
          if (!root.parentNode) {
            document.body.insertBefore(root, document.body.lastChild);
          }
        }, 100);

        _appendChild = document.body.appendChild;
        document.body.appendChild = (elem) => {
          if (!root.parentNode) {
            document.body.insertBefore(root, document.body.lastChild);
          }
          return document.body.insertBefore(elem, root);
        };

        let observer = new MutationObserver(keepRoot);
        observer.observe(document.body, {childList: true});
        // if (editorApp.state.showCEIntroModal) {
        //   updateUserFlag('COLLECT_EVERYTHING_INTRO_MODAL');
        // }
        resolve();
      }, 1500); // makes for a smoother animation if we allow a buffer once page is loaded
    };

    if (document.readyState === 'complete') {
      renderEditor();
    } else {
      window.addEventListener('load', renderEditor);
    }
  });
};

localeSvc.init();

const shiftHostPageDown = function (hostElements) {
  // The goal is to move the entire page down by the height of the control bar
  // so that it doesn't cover anything. For pages with no absolute or fixed positioning,
  // padding works fine. However, we also need to adjust for absolutely positioned elements
  //
  // NOTE: This should be executed before we load the editor since it iterates all elements on the page

  // update body padding to allow room for the header
  // const bodyCss = getComputedStyle(document.body);
  // const newPaddingTop = (parseInt(bodyCss['margin-top'], 10) || 0) + HEADER_HEIGHT;
  // document.body.style.cssText +=
  //   '; padding-top:' + newPaddingTop + 'px !important; transition: margin 300ms cubic-bezier(0, 0, 0, 0.97);';

  // const hasAncestor = (el, cssProp, vals) => {
  //   for (let curEl = el.parentNode; curEl.parentNode; curEl = curEl.parentNode) {
  //     const parentCss = getComputedStyle(curEl);
  //     if (vals.includes(parentCss[cssProp])) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  // Array.from(hostElements).forEach(el => {
  //   const css = getComputedStyle(el);
  //   if (css.position === 'fixed' ||
  //       (css.position === 'absolute' && !hasAncestor(el, 'position', ['absolute', 'fixed', 'relative']))) {
  //     const origBodyStyles = document.body.style.cssText;
  //     const origElBounds = el.getBoundingClientRect();
  //     document.body.style['margin-top'] = (parseInt(document.body.style['margin-top'], 10) || 0) + 1 + 'px';
  //     const newElBounds = el.getBoundingClientRect();
  //     document.body.style.cssText = origBodyStyles;
  //     if (origElBounds.top === newElBounds.top) {
  //       const newTop = (parseInt(css.top, 10) || 0) + HEADER_HEIGHT;
  //       console.log(111, newTop)
  //       el.style.cssText += '; top:' + newTop + 'px !important; transition: top 500ms ease-out;';
  //     }
  //   }
  // });
};



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/